import { Paths } from './Paths.js';

export const App = () => {
  return (
    <Paths/>
  );
}